/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

// globals jQuery, Timing

let $ = jQuery;
import isEmpty from "lodash/isEmpty";
import OkC from "shared/util/OkcApi";
import Context from "shared/util/Context";

import { isDev } from "shared/util/EnvironmentHelpers";

window.Timing = {
	throwStats() {
		/*
		Event order:
		1. performance.timing.navigationStart
		2. performance.timing.requestStart
		3. performance.timing.responseStart
		4. performance.timing.domLoading
		5. performance.timing.domInteractive
		6. performance.timing.loadEventStart (or this function)
		*/

		try {
			let { navigationStart } = performance.timing;
			let { requestStart } = performance.timing;
			let { responseStart } = performance.timing;
			let { domLoading } = performance.timing;
			let { domInteractive } = performance.timing;

			let total = domInteractive - navigationStart;
			let pagefetch = responseStart - requestStart;
			let pageload = domInteractive - domLoading;

			let service = Context.get("service");

			let timingExperiments = Context.get("timingExperiments");

			let data = { total, pagefetch, pageload, service };

			if (timingExperiments && !isEmpty(timingExperiments)) {
				data.experiments = timingExperiments;
			}

			return OkC.post(
				"/okc/pagetiming",
				{
					api: 1,
					data,
				},
			);
		} catch (e) {
			return typeof window.onerror === "function"
				? window.onerror(e.stack, "timing.js", 20)
				: undefined;
		}
	},
};

$(window).on("load", function() {
	if (
		__guard__(
			typeof performance !== "undefined" && performance !== null
				? performance.timing
				: undefined,
			x => x.navigationStart
		) == null ||
		typeof _ === "undefined" ||
		_ === null
	) {
		return;
	}

	// random sampling, 1/10
	if ((Math.floor(Math.random() * 10)) !== 1 && !isDev) {
		return;
	}

	return setTimeout(() => Timing.throwStats(), 100);
});

function __guard__(value, transform) {
	return typeof value !== "undefined" && value !== null
		? transform(value)
		: undefined;
}



// WEBPACK FOOTER //
// ./src/legacy/timing.js